var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconTravelInsuranceCover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0-4.5 0Zm-1.5 7.5a3.75 3.75 0 0 1 7.5 0m-18-7.5a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0-4.5 0Zm-1.5 7.5a3.75 3.75 0 0 1 7.5 0m10.5-12.75a8.25 8.25 0 0 0-16.5 0Zm-8.25 0V18m0-15.75V.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTravelInsuranceCover);
export default __webpack_public_path__ + "static/media/streamline-icon-travel-insurance-cover.97d993b7.svg";
export { ForwardRef as ReactComponent };